<template>
  <c-select
    title="РЕГИОН:"
    form-group
    :form-group-margin-bottom="formGroupMarginBottom"
    :options="getRegions"
    :value="selectedRegion"
    :disabled="getRegions.length === 1"
    @input="changeSelectedRegion($event)"
  />
</template>

<script>
import CSelect from '../../../../../../resources/js/components/ui/CSelect.vue'
import { mapGetters, mapState, mapActions } from 'vuex'

/**
 * Выпадающий список регионов.
 */
export default {
  name: 'ClientProjectsRegionSelect',
  components: {
    CSelect
  },
  props: {
    /**
     * Отступ снизу от div.form-group.
     */
    formGroupMarginBottom: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      getRegions: 'seo/client/projects/getRegions'
    }),
    ...mapState({
      selectedRegion: state => state.seo.client.projects.selectedRegion
    })
  },
  methods: {
    ...mapActions({
      changeSelectedRegion: 'seo/client/projects/changeSelectedRegion'
    })
  }
}
</script>
